'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

exports.processRecipient = processRecipient;
exports.processRecipients = processRecipients;
exports.getFilteredRecipients = getFilteredRecipients;
exports.groupRecipients = groupRecipients;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _strings = require('helpers/strings');

var _utils = require('helpers/utils');

var _ordering = require('utils/ordering');

var _ordering2 = _interopRequireDefault(_ordering);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filteredFields = ['id', 'fullName', 'email'];

function processRecipient(recipient) {
  var processedRecipient = (0, _extends3.default)({}, recipient);
  processedRecipient.id = processedRecipient.id || processedRecipient.recipientId || processedRecipient.userId;
  processedRecipient.expirationDate = (0, _moment2.default)(processedRecipient.recepEd || new Date());
  processedRecipient.fullName = (0, _strings.concat)(' ', processedRecipient.name, processedRecipient.surname);
  return processedRecipient;
}

function processRecipients() {
  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return recipients.map(processRecipient);
}

function getFilteredRecipients(_ref) {
  var recipients = _ref.recipients,
      activeOrder = _ref.activeOrder,
      order = _ref.order,
      kw = _ref.kw;

  var data = (0, _utils.filterObjectsByKws)({ objects: processRecipients(recipients), fields: filteredFields, kw: kw });
  return (0, _ordering2.default)({ data: data, activeOrder: activeOrder, order: order });
}

function groupRecipients() {
  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var groupedRecipients = [];
  var groupMap = {};

  recipients.map(function (recipient) {
    if (recipient.groupId) {
      if ((0, _isUndefined3.default)(groupMap[recipient.groupId])) {
        groupMap[recipient.groupId] = groupedRecipients.length;
      }
      var groupIndex = groupMap[recipient.groupId];

      if (!groupedRecipients[groupIndex]) {
        groupedRecipients[groupIndex] = {
          groupId: recipient.groupId,
          groupName: recipient.groupName,
          recipients: []
        };
      }
      groupedRecipients[groupIndex].recipients.push(processRecipient(recipient));
    } else {
      groupedRecipients.push(processRecipient(recipient));
    }
  });

  return groupedRecipients;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/recipients.js
// module id = 264
// module chunks = 1